import Vue from "vue";
import VueRouter from "vue-router";
import souhu from "../views/souhu/souhu.vue";
import alipaysh from "../views/hz/alipaysh.vue";

Vue.use(VueRouter);

const routes = [
  //后置的只能单独建文件，支付宝要封
  // {
  //   path: "/",
  //   name: "souhu",
  //   component: souhu,
  //   meta: {
  //     title: "搜狐联合会员" // 可以在这里设置自定义标题
  //   }
  // },
  {
    path: "/",
    name: "alipaysh",
    //https://qb.78keji.cn/lead/?path=Ali&a=a1a2a3&d=E510g6aB
    component: alipaysh,
    meta: {
      title: "搜狐视频会员" // 可以在这里设置自定义标题
    }
  },

  {
    path: "/shpo",
    name: "shpo",
    component: () =>
      import(/* webpackChunkName: "shpo" */ "../views/souhu/LH2766.vue"),
    meta: {
      title: "搜狐联合会员"
    }
  },
  {
    path: "/shwv1",
    name: "shwv1",
    component: () =>
      import(/* webpackChunkName: "shw" */ "../views/souhu/shwv1.vue"),
    meta: {
      title: "搜狐联合会员"
    }
  },
    {
    path: "/hz",
    name: "hz",
    component: () =>
      import(/* webpackChunkName: "shw" */ "../views/hz/hz.vue"),
    meta: {
      title: "搜狐视频会员"
    }
  },
  {
    path: "/shw",
    name: "shw",
    component: () =>
      import(/* webpackChunkName: "shw" */ "../views/souhu/shw.vue"),
    meta: {
      title: "搜狐联合会员"
    }
  },
  {
    path: "/shpov1",
    name: "shpov1",
    component: () =>
      import(/* webpackChunkName: "shpov1" */ "../views/souhu/LH2771.vue"),
    meta: {
      title: "搜狐联合会员"
    }
  },
  {
    path: "/shpov2",
    name: "shpov2",
    component: () =>
      import(/* webpackChunkName: "shpov2" */ "../views/souhu/shpov2.vue"),
    meta: {
      title: "搜狐联合会员"
    }
  },

  {
    path: "/shzf",
    name: "shzf",
    component: () =>
      import(/* webpackChunkName: "shpov1" */ "../views/souhu/LH2768.vue"),
    meta: {
      title: "搜狐联合会员"
    }
  },
    {
    path: "/gdt",
    name: "gdt",
    component: () =>
      import(/* webpackChunkName: "shpov1" */ "../views/souhu/gdt.vue"),
    meta: {
      title: "搜狐联合会员"
    }
  },
  {
    path: "/404",
    name: "404",
    component: () =>
      import(/* webpackChunkName: "404" */ "../views/404.vue"),
    meta: {
      title: "404"
    }
  },
];

const router = new VueRouter({
  mode: "history",
  // base: '/shAli',//前置
  base: '/Ali',//后置

  routes,
});

// 路由守卫：每次路由变化时设置页面标题
router.beforeEach((to, from, next) => {
  // 从路由的meta中获取标题，如果没有则使用路由的name
  document.title = to.meta.title || to.name || '搜狐联合会员';
  next();
});

export default router;